import { useCallback } from 'react'
import { SprintRepository } from '../../applications/ports/sprintRepository'
import api from '../../lib/commons/api'
import { ReferencedSprintEntity } from '../../domain/value-object/ReferencedEntity'

export const useSprintRepository = (): SprintRepository => {
  const fetchActiveAsReferencedEntity = useCallback(
    async (teamUuid: string): Promise<ReferencedSprintEntity[]> => {
      const response = await api.functional.request(
        'GET',
        '/api/v1/projects/scrums/sprints',
        {
          teamUuid,
          statusList: ['STANDBY', 'INPROGRESS', 'FINISHED', 'CANCELED'],
        },
        true
      )
      // TODO: Consider the logic to assure type in runtime.
      return response.json
    },
    []
  )
  const fetchAsReferencedEntity = useCallback(async (uuid: string) => {
    const response = await api.functional.request(
      'GET',
      '/api/v1/projects/scrums/sprints/referenced_values',
      { uuid },
      true
    )
    // TODO: Consider the logic to assure type in runtime.
    return response.json
  }, [])

  return { fetchActiveAsReferencedEntity, fetchAsReferencedEntity }
}
